const JobProfileConst = {
  DEFAULT_RANGE: { min: 1, max: 10 },
  DEFAULT_BOUND: 2,
};

export default JobProfileConst;
